<style lang="less">
.analysis-teacher {
  background: #f3f3f3;
  position: relative;
  padding: 18px;
  box-sizing: border-box;
  .main-1 {
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    box-sizing: border-box;
    .header {
      width: 100%;
      height: 32px;
      position: relative;
      .search {
        position: absolute;
        width: 360px;
        height: 30px;
        display: flex;
        right: 10px;
      }
    }
    .header-next {
      width: 100%;
      height: 32px;
      position: relative;
      display: flex;
      .class-info {
        width: 72px;
        height: 100%;
        line-height: 32px;
        text-align: center;
      }
      .choose-date {
        margin-right: 10px;
        height: 32px !important;
        .ivu-input {
          height: 32px !important;
        }
      }
      .choose-type {
        height: 32px !important;
        .ivu-select-input {
          height: 32px !important;
        }
        .ivu-select-selection {
          height: 32px !important;
        }
      }
    }
    .contain-part {
      position: relative;
      width: 100%;
      height: 100%;
      margin: 24px 0;
      box-sizing: border-box;
    }
    .footer {
      width: 100%;
      height: auto;
    }
  }
  .main-2 {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    padding: 12px;
    box-sizing: border-box;
    display: flex;
    .part-left {
      width: 40%;
      height: 100%;
      .header-next {
        margin-top: 12px;
        width: 100%;
        height: 32px;
        position: relative;
        display: flex;
        .class-info {
          width: 72px;
          height: 100%;
          line-height: 32px;
          text-align: center;
        }
      }
      .contain-part {
        position: relative;
        width: 100%;
        height: 100%;
        margin: 24px 0;
        box-sizing: border-box;
        .wh_content_all {
          background: #696969;
          border-radius: 6px;
        }
        .wh_content_item .wh_isToday {
          background: #fff;
          color: #111;
        }
        .wh_content_item .wh_chose_day {
          background: rgb(214, 214, 214);
          color: rgb(27, 0, 0);
        }
      }
    }
    .part-right {
      width: 60%;
      height: 100%;
      background: #fff;
      padding: 12px;
      box-sizing: border-box;
      border-radius: 10px;
      .header-next {
        width: 100%;
        height: 32px;
        position: relative;
        display: flex;
        .class-info {
          width: 72px;
          height: 100%;
          line-height: 32px;
          text-align: center;
        }
        .choose-type {
          height: 32px !important;
          .ivu-select-input {
            height: 32px !important;
          }
          .ivu-select-selection {
            height: 32px !important;
          }
        }
      }
      .punch-card {
        width: 100%;
        padding-top: 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
        .info {
          width: 100px;
          height: 50px;
          line-height: 25px;
          text-align: center;
          border-radius: 5px;
          border: #f3f3f3 1px solid;
        }
      }
      .contain-part {
        position: relative;
        width: 100%;
        height: 100%;
        margin: 24px 0;
        box-sizing: border-box;
      }
      .footer {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
<template>
  <div class="analysis-teacher">
    <div class="main-1" v-if="showPage == 0">
      <div class="header-next">
        <Input
          @on-search="GetActivityList"
          @on-change="GetActivityList"
          v-model="activityName"
          clearable
          placeholder="输入活动名称"
          style="width:200px;margin-right: 28px;"
        />
        <Select
          class="choose-type"
          v-model="activityStatus"
          placeholder="请选择作业状态"
          filterable
          style="width:240px;height: 32px;"
        >
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <DatePicker
          class="choose-date"
          :value="dateTime"
          format="yyyy/MM/dd"
          type="daterange"
          placement="bottom-end"
          placeholder="选择起止日期"
          :options="shortcutsOption"
          @on-change="SetNewAvgDate"
        />
        <Button style="margin-right: 10px;" type="info" @click="SearchWork">搜索</Button>
        <Button style="margin-right: 10px;" @click="ClearData">重置</Button>
      </div>
      <div class="contain-part">
        <i-table border :columns="workList" :data="activityList"/>
      </div>
      <div class="footer">
        <Page
          :total="count1"
          :page-size="pageSize1"
          :page-size-opts="[10,20]"
          show-total
          @on-change="ChangePage"
          @on-page-size-change="ChangePageSize"
          show-elevator
          show-sizer
        />
      </div>
    </div>
    <div class="main-2" v-if="showPage == 1">
      <div class="part-left">
        <div class="header-next">
          <Button @click="Reback(0)" type="primary">
            <Icon type="ios-arrow-back"/>返回
          </Button>
          <div class="class-info">打卡数据</div>
        </div>
        <div class="contain-part">
          <Calendar
            v-on:choseDay="ClickDay"
            v-on:changeMonth="ChangeDate"
            :agoDayHide='startTime'
            :futureDayHide='endTime'
            :sundayStart="true"
          />
          <!-- <el-calendar
            v-model="showData"
            @click="ShowChoose(data)"
          >></el-calendar>-->
        </div>
      </div>
      <div class="part-right">
        <div class="header-next">
          <Select
            class="choose-type"
            v-model="groupId"
            placeholder="请选择活动分组"
            filterable
            style="width:240px;height: 32px;"
          >
            <Option v-for="item in groupList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
          <Button type="primary" style="margin-left: 120px;" icon="ios-search" @click="GetGroupInfo">搜索</Button>
          <Button style="margin-left: 20px;" @click="ClearAll">重置</Button>
        </div>
        <div class="punch-card">
          <div class="info">
            当日打卡学生
            <br>{{punchNum}}
          </div>
          <div class="info">
            当日打卡率
            <br>{{punchRate}}
          </div>
        </div>
        <div class="contain-part">
          <i-table border :columns="dataList" :data="punchList"/>
        </div>
        <div class="footer">
          <Page
            :total="count2"
            :page-size="pageSize2"
            :page-size-opts="[10,20]"
            show-total
            @on-change="ChangePageData"
            @on-page-size-change="ChangePageSizeData"
            show-elevator
            show-sizer
          />
        </div>
      </div>
    </div>
    <div class="main-1" v-if="showPage == 2">
      <div class="header-next">
        <Button @click="Reback(0)" type="primary">
          <Icon type="ios-arrow-back"/>返回
        </Button>
        <div class="class-info">引流明细</div>
        <!-- <Input
          @on-search="GetActivityList"
          @on-change="GetActivityList"
          v-model="activityName"
          clearable
          placeholder="输入活动名称"
          style="width:360px;"
        /> -->
      </div>
      <div class="contain-part">
        <i-table border :columns="studentList" :data="inList"/>
      </div>
      <!-- <div class="footer">
          <Page
            :total="count3"
            :page-size="pageSize3"
            :page-size-opts="[10,20]"
            show-total
            @on-change="ChangePageIn"
            @on-page-size-change="ChangePageSizeIn"
            show-elevator
            show-sizer
          />
        </div> -->
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { setTimeout } from 'timers'
const DAT_MINI_SECOND = 3600 * 1000 * 24
import analysisApi from '@/lib/api/analysis'
// eslint-disable-next-line no-unused-vars
import cisTip from '@/components/cisTip.vue'
import Calendar from 'vue-calendar-component'
export default {
  name: 'teacherData',
  data() {
    return {
      activityName: '',
      activityStatus: '',
      ActivityId: '',
      startTime: '',
      endTime: '',
      punchNum: '',
      punchRate: '',
      groupId: '', // 分组ID
      dateTime: [], // 起止日期
      showData: new Date(),
      buttonSize: 'large',
      showPage: 0,
      count1: 0,
      start1: 0,
      pageSize1: 10,
      count2: 0,
      start2: 0,
      pageSize2: 10,
      count3: 0,
      start3: 0,
      pageSize3: 10,
      needdate: '',
      shortcutsOption: {
        shortcuts: [
          {
            text: '今天',
            value() {
              const end = new Date()
              const start = new Date()
              return [start, end]
            }
          },
          {
            text: '昨天',
            value() {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND)
              end.setTime(end.getTime() - DAT_MINI_SECOND)
              return [start, end]
            }
          },
          {
            text: '过去7天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 7)
              return [start, end]
            }
          },
          {
            text: '过去30天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 30)
              return [start, end]
            }
          }
          // {
          //   text: '过去60天',
          //   value() {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - DAT_MINI_SECOND * 60);
          //     return [start, end];
          //   }
          // },
          // {
          //   text: '过去90天',
          //   value() {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - DAT_MINI_SECOND * 90);
          //     return [start, end];
          //   }
          // }
        ]
      },
      typeList: [
        {
          value: '1',
          label: '进行中'
        },
        {
          value: '2',
          label: '已截止'
        }
      ],
      groupList: [
      ],
      workList: [
        {
          title: 'ID',
          width: 80,
          key: 'id'
        },
        {
          title: '活动名称',
          key: 'title'
        },
        {
          title: '活动时间',
          key: 'actTime'
        },
        {
          title: '活动状态',
          key: 'taskStatus'
        },
        {
          title: '参与人数',
          // width: 120,
          key: 'join_num'
        },
        {
          title: '完成率',
          key: 'completeRate'
        },
        {
          title: '分享次数',
          key: 'share_num'
        },
        {
          title: '浏览次数',
          key: 'pv_num'
        },
        {
          title: '引流人数',
          key: 'from_num'
        },
        {
          title: '操作',
          key: 'action',
          width: 180,
          align: 'center',
          render: (h, params) => {
            const editBtn = h('i-button', {
              on: {
                click: () => {
                  this.CheckData(1, params.row.id)
                }
              },
              props: {
                type: 'primary'
              }
            }, '打卡数')
            const emptyBox = h('div', {
              style: {
                width: '16px'
              }
            })
            const delBtn = h('i-button', {
              on: {
                click: () => {
                  this.CheckDataIn(2, params.row.id)
                }
              },
              props: {
                type: 'primary'
              },
              style: {
                background: '#e6f9fa',
                border: '1px #2f9eff solid',
                color: '#2f9eff'
              }
            }, '引流数')
            return h('div', {
              style: {
                display: 'flex'
              }
            }, [editBtn, emptyBox, delBtn])
          }
        }
      ],
      studentList: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '分享学生',
          key: 'share_stu_name'
        },
        {
          title: '引流号码',
          key: 'mobile'
        },
        {
          title: '引流学生姓名',
          key: 'stu_name'
        },
        {
          title: '填写时间',
          key: 'startTime'
        },
        {
          title: '参加活动天数',
          key: 'punch_day'
        }
      ],
      dataList: [
        {
          title: 'ID',
          key: 'uid'
        },
        {
          title: '学生姓名',
          key: 'name'
        },
        {
          title: '活动组',
          key: 'punch_group_name'
        },
        {
          title: '所属班级',
          key: 'group_names'
        },
        {
          title: '班级老师',
          key: 'teacher_names'
        },
        {
          title: '打卡分数',
          key: 'score'
        },
        {
          title: '分享状态',
          key: 'isShare'
        }
      ],
      activityList: [],
      punchList: [],
      inList: []
    }
  },
  created() {
    this.GetActivityList()
    // this.ShowChoose()
  },
  components: {
    Calendar
  },
  methods: {
    ClearData() {
      this.dateTime = []
      this.activityName = ''
      this.activityStatus = ''
    },
    // 获取活动列表
    GetActivityList() {
      analysisApi
        .SearchPunchData({
          status: this.activityStatus,
          keyword: this.activityName,
          start: this.start1,
          rows: this.pageSize1,
          startData: this.dateTime.length == 0
            ? ''
            : new Date(this.dateTime[0]).format('yyyy-MM-dd'),
          endData: this.dateTime.length == 0
            ? ''
            : new Date(this.dateTime[1]).format('yyyy-MM-dd')
        })
        .then(res => {
          console.log('活动数据列表', res)
          const teacherInfo = res
          this.list = teacherInfo.data.list // 所有数据
          this.count1 = teacherInfo.data.count // 总条数
          this.activityList = teacherInfo.data.list.map(
            item => {
              // console.log(new Date().format('yyyy-MM-dd HH:mm:ss'),new Date(parseInt(item.date_end_time) * 1000).format('yyyy-MM-dd HH:mm:ss'))
              if (new Date() > new Date(parseInt(item.end_time) * 1000)) {
                item.taskStatus = '已截止'
              } else {
                item.taskStatus = '进行中'
              }
              // eslint-disable-next-line no-return-assign
              return {
                ...item,
                taskStatus: item.taskStatus,
                completeRate: item.workScore = parseFloat(item.complete_rate * 100).toFixed(1) + '%',
                actTime: `${item.date_begin_time}-${item.date_end_time}`
              }
            }
          ) // 点读作品列表
        })
    },
    // 活动数据首页分页栏
    ChangePage(index) {
      this.start1 = (index - 1) * this.pageSize1
      this.GetActivityList()
    },
    ChangePageSize(pageSize) {
      this.pageSize1 = pageSize
      this.GetActivityList()
    },
    // 活动数据打卡数分页栏
    ChangePageData(index) {
      this.start2 = (index - 1) * this.pageSize2
      this.GetGroupInfo()
    },
    ChangePageSizeData(pageSize) {
      this.pageSize2 = pageSize
      this.GetGroupInfo()
    },
    // 活动数据打卡数分页栏
    ChangePageIn(index) {
      this.start3 = (index - 1) * this.pageSize3
      this.GetInInfo()
    },
    ChangePageSizeIn(pageSize) {
      this.pageSize3 = pageSize
      this.GetInInfo()
    },
    CheckData(page, id) {
      this.showPage = page
      this.ActivityId = id
      console.log(this.showPage)
      this.GetPunchInfo()
      if (this.showPage == 1) {
        this.needdate = new Date().format('yyyy-MM-dd')
        console.log(this.needdate)
      }
    },
    CheckDataIn(page, id) {
      this.showPage = page
      this.ActivityId = id
      console.log(this.showPage)
      this.GetInInfo()
    },
    // 引流数据
    GetInInfo() {
      analysisApi
        .SearchInInfo({
          punchId: this.ActivityId
        })
        .then(res => {
          console.log('引流列表', res)
          const teacherInfo = res.data
          // this.inList = teacherInfo
          this.inList = teacherInfo.map((item) => {
            return {
              ...item,
              startTime: new Date(parseInt(item.create_time) * 1000).format('yyyy-MM-dd HH:mm:ss')
            }
          })
        })
    },
    GetPunchInfo() {
      analysisApi
        .SearchPunchInfo({
          punchId: this.ActivityId
        })
        .then(res => {
          console.log('打卡列表', res)
          const teacherInfo = res
          this.startTime = teacherInfo.data.begin_time
          this.endTime = teacherInfo.data.end_time
          console.log(this.endTime)
          this.groupList = teacherInfo.data.punch_group_info
          const d = new Date(this.startTime * 1000) // 根据时间戳生成的时间对象
          this.needdate = (d.getFullYear()) + '-' +
                (d.getMonth() + 1) + '-' +
                (d.getDate())
          console.log('日期', this.needdate)
          console.log(this.groupList)
          if (this.groupList.length > 0) {
            this.groupId = this.groupList[0].id
            this.GetGroupInfo()
          } else {
            this.GetGroupInfo()
          }
        })
    },
    GetGroupInfo() {
      analysisApi
        .SearchGroupInfo({
          punchId: this.ActivityId,
          punchDate: this.needdate,
          groupId: this.groupId,
          start: this.start2,
          rows: this.pageSize2
        })
        .then(res => {
          console.log('分组数据', res)
          const teacherInfo = res
          this.list = teacherInfo.data.list // 所有数据
          this.count2 = teacherInfo.data.count // 总条数
          this.punchNum = teacherInfo.data.current_day_num
          this.punchRate = parseFloat(teacherInfo.data.current_day_rate * 100).toFixed(1) + '%'
          this.punchList = teacherInfo.data.list.map(
            item => {
              // item.group_names.split(',')
              // item.teacher_names.split(',')
              // item.groupTest = item.group_names.toString();
              if (item.is_share == 0) {
                item.isShare = '未分享'
              } else {
                item.isShare = '已分享'
              }
              return {
                ...item,
                isShare: item.isShare
                // groupNames: item.groupTest.split(','),
                // groupTeachers: item.teacher_names.split(',')
              }
            }
          ) // 点读作品列表
        })
    },
    Reback(page) {
      this.showPage = page
      this.start = 0
      this.pageSize = 0
      this.groupId = ''
      this.punchList = []
      this.inList = []
    },
    SetNewAvgDate(format) {
      this.dateTime = format
      console.log(this.dateTime)
    },
    SearchWork() {
      this.GetActivityList()
    },
    ClickDay(data) {
      console.log(data) // 选中某天
      this.needdate = data
      this.GetGroupInfo()
    },
    ClearAll() {
      this.groupId = ''
    },
    ChangeDate(data) {
      console.log(data) // 左右点击切换月份
    }
  }
}
</script>
